import { type Common } from './common.js';
import { type EhrTwoFactor } from './models/index.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllPhoneNumbers(): Promise<EhrTwoFactor.PhoneNumber[]> {
    const url = this.common.constructPath('/ehr-two-factor/');
    const { phoneNumbers } = await this.common.getJSON(url);
    return phoneNumbers.map((phoneNumber: EhrTwoFactor.PhoneNumber) => ({
      ...phoneNumber,
      updated: new Date(phoneNumber.updated),
    }));
  }

  async findOneByPhoneNumber(phoneNumber: string): Promise<EhrTwoFactor.EhrTwoFactor> {
    const url = this.common.constructPath(`/ehr-two-factor/${phoneNumber}`);
    const { twoFactorSms } = await this.common.getJSON(url);
    return {
      ...twoFactorSms,
      created: new Date(twoFactorSms.created),
      updated: new Date(twoFactorSms.updated),
    };
  }
}
